import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { branding } from "../utils/branding";

// Styles for chat bubbles and layout
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 12,
  },
  userMessage: {
    backgroundColor: "#f0f0f0",
    marginBottom: 8,
    padding: 8,
    borderRadius: 8,
  },
  botMessage: {
    backgroundColor: "#d1f0ff",
    marginBottom: 8,
    padding: 8,
    borderRadius: 8,
    fontStyle: "italic",
  },
  timestamp: {
    fontSize: 10,
    color: "#888",
    marginBottom: 2,
  },
});

const ChatPDF = ({ sessionId, messages }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={{ fontSize: 16, marginBottom: 10 }}>
        Chat Transcript - {sessionId}
      </Text>
      {messages.map((chat, idx) => (
        <View key={idx}>
          <Text style={styles.timestamp}>
            User ({new Date(chat.createdAt).toLocaleTimeString()}):
          </Text>
          <Text style={styles.userMessage}>{chat.user_input}</Text>

          <Text style={styles.timestamp}>
            {branding("ZeroBox")} (
            {new Date(chat.createdAt).toLocaleTimeString()}):
          </Text>
          <Text style={styles.botMessage}>{chat.bot_response}</Text>
        </View>
      ))}
    </Page>
  </Document>
);

export default ChatPDF;
